// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Specular_Internal_Incremental_Optional = require("../Specular.Internal.Incremental.Optional/index.js");
var foreachUntil = function (array, fn) {
    return $foreign["_foreachUntil"](Specular_Internal_Incremental_Optional.none, array, fn);
};
module.exports = {
    foreachUntil: foreachUntil,
    "_foreachUntil": $foreign["_foreachUntil"]
};
//# sourceMappingURL=index.js.map
